import { EstablishmentCompanyData } from '@/features/company/types/company.type';
import { LoadingEstablishmentTooltipDetails } from '@/features/establishments/pages/Map/components/MarkerTooltip/LoadingTooltipDetails';
import { useEstablishmentMap } from '@/features/establishments/stores/useEstablishmentMap.store';
import { OverlayView } from '@react-google-maps/api';
import { twMerge } from 'tailwind-merge';
import { Cluster } from '../../types/cluster';
import { EstablishmentTooltipDetails } from './EstablishmentTooltipDetails';

interface MarkerTooltipProps {
  cluster: Partial<Cluster>;
  companyKind?: string;
  establishment?: EstablishmentCompanyData;
  isLoadingEstablishmentData: boolean;
}

export const MarkerTooltip = ({ cluster, companyKind, establishment, isLoadingEstablishmentData }: MarkerTooltipProps) => {
  const { colorScheme } = useEstablishmentMap();

  return (
    <OverlayView
      position={{
        lat: Number(cluster.latitude),
        lng: Number(cluster.longitude),
      }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div className='mb-12'>
        <div className={
          twMerge(
            'establishment-map-tooltip tooltip-content items-start justify-between w-[336px] backdrop-blur-3xl flex-col bg-white-200 z-50 rounded-md absolute bottom-[50px]',
            colorScheme === 'light' && 'bg-map-search-75'
          )
        }>
          {isLoadingEstablishmentData ? (
            <LoadingEstablishmentTooltipDetails />
          ) : (
            <EstablishmentTooltipDetails companyKind={companyKind} establishment={establishment} />
          )}
        </div>
      </div>
    </OverlayView>
  );
};
